export const SET_LAST_GENERATED_MEMBER = "SET_LAST_GENERATED_MEMBER";
export const SET_MINT_ENABLED_STATUS = "SET_MINT_ENABLED_STATUS";
export const SET_MENROL_ENABLED_STATUS = "SET_MENROL_ENABLED_STATUS";
export const SET_CLIENT_SELECTOR_CLIENT = "SET_CLIENT_SELECTOR_CLIENT";
export const PATCH_CLIENT_STATUS_TYPE = "PATCH_CLIENT_STATUS_TYPE";



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/clientActionTypes.js